import { BASE_API } from "../utils/constants";
import { authHeader } from "./token";

async function request(url, token, options = {}) {
  const response = await fetch(url, {
    ...options,
    headers: { ...authHeader(token), "Content-Type": "application/json", ...options.headers },
  });
  if (response.status === 204) return null;
  const body = await response.json().catch(() => null);
  if (!response.ok) {
    const error = new Error("No se pudo guardar el cliente");
    error.fields = body; // errores por campo del backend (ej. doc_number)
    throw error;
  }
  return body;
}

export const getCustomersApi = (search, token) =>
  request(`${BASE_API}/api/customers/?search=${encodeURIComponent(search || "")}`, token);

export const createCustomerApi = (data, token) =>
  request(`${BASE_API}/api/customers/`, token, { method: "POST", body: JSON.stringify(data) });

export const updateCustomerApi = (id, data, token) =>
  request(`${BASE_API}/api/customers/${id}/`, token, { method: "PATCH", body: JSON.stringify(data) });

export const deleteCustomerApi = (id, token) =>
  request(`${BASE_API}/api/customers/${id}/`, token, { method: "DELETE" });
